// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { EnterpriseProgramsV1 } from './EnterpriseProgramsV1';
import { ProgramSwitcherSelectionsV1 } from './ProgramSwitcherSelectionsV1';
import { ProgramsV1 } from './ProgramsV1';
import { UsersV1 } from './UsersV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type ProgramMembershipState =
  | 'MEMBER'
  | 'INVITED'
  | 'INVITED_EMAIL_NOT_VERIFIED'
  | 'WHITELISTED'
  | 'NOT_MEMBER'
  | 'DELETED_MEMBER'
  | 'SOFT_DELETED_MEMBER';

export type ProgramRole = 'DERIVED_PROGRAM_ADMIN' | 'PROGRAM_ADMIN' | 'MEMBER';

export interface GenericExternalUserData {
  fullName: string;
  email: string;
  externalId?: string | null;
}

export interface ExternalUserDataGenericExternalUserData {
  typeName: 'genericExternalUserData';
  definition: GenericExternalUserData;
}

export type ExternalUserData = ExternalUserDataGenericExternalUserData;

export type ExternalUserDataTypeName = 'genericExternalUserData';

export interface ProgramMembershipsV2 {
  id: string;
  userId: number;
  programId: string;
  membershipState: ProgramMembershipState;
  role?: ProgramRole | null;
  createdAt?: number | null;
  invitationId?: string | null;
  externalUserData: ExternalUserData;
  deletedAt?: number | null;
  rosterIds: Array<string>;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramMembershipsV2Connection {
  elements: Array<ProgramMembershipsV2> | null;
  linked: {
    programSwitcherSelectionsV1: Array<ProgramSwitcherSelectionsV1> | null;
    usersV1: Array<UsersV1> | null;
    enterpriseProgramsV1: Array<EnterpriseProgramsV1> | null;
    programsV1: Array<ProgramsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramMembershipsV2ByUserQuery {
  ProgramMembershipsV2: {
    byUser: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2ByUserQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface ProgramMembershipsV2DeleteQuery {
  ProgramMembershipsV2: {
    delete: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2DeleteQueryVariables {
  id: string;
  isSoftDelete?: string | null;
  includes?: string | null;
}

export interface ProgramMembershipsV2DeletedMembershipsByUserQuery {
  ProgramMembershipsV2: {
    deletedMembershipsByUser: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2DeletedMembershipsByUserQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface ProgramMembershipsV2GetQuery {
  ProgramMembershipsV2: {
    get: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramMembershipsV2MultiGetQuery {
  ProgramMembershipsV2: {
    multiGet: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface ProgramMembershipsV2CreateMutation {
  ProgramMembershipsV2: {
    create: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2CreateMutationVariables {
  includes?: string | null;
}

export interface ProgramMembershipsV2MultiDeleteMutation {
  ProgramMembershipsV2: {
    multiDelete: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2MultiDeleteMutationVariables {
  programId: string;
  sendNotification?: string | null;
  isSoftDelete?: string | null;
  includes?: string | null;
}

export interface ProgramMembershipsV2ResendVerificationEmailMutation {
  ProgramMembershipsV2: {
    resendVerificationEmail: ProgramMembershipsV2Connection | null;
  } | null;
}

export interface ProgramMembershipsV2ResendVerificationEmailMutationVariables {
  id: string;
  redirectUrl?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ProgramMembershipsV2NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programMemberships.v2' as const;

  declare id: string;

  declare userId: number;

  declare programId: string;

  declare membershipState: ProgramMembershipState;

  declare role?: ProgramRole | null;

  declare createdAt?: number | null;

  declare invitationId?: string | null;

  declare externalUserData: ExternalUserData;

  declare deletedAt?: number | null;

  declare rosterIds: Array<string>;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramMembershipsV2>) {
    super(params);
  }
}
